import {XauditModel} from '../xaudit.model';
import {NoteDataModel} from './note-data.model';

export class NoteGroupDataModel extends XauditModel {
  public NoteGroupId: string;
  public ParentObjectName: string;
  public ObjectId: string;
  public NoteId: string;
  public PatientId: string;
  public dataNote: NoteDataModel;

  // Front end use only
  public display: boolean = true;
  public isEditable: boolean = true;
}
